import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
export default defineComponent({
  name: "BaseInput",
  props: {
    value: {
      type: null,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    browserAutocomplete: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      handleKeypressEnter,
      valueModel
    } = useCoreInput({
      value
    });
    const inputRef = ref();
    const focus = () => {
      var _inputRef$value;
      inputRef == null ? void 0 : (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.focus();
    };
    const blur = () => {
      var _inputRef$value2;
      inputRef == null ? void 0 : (_inputRef$value2 = inputRef.value) == null ? void 0 : _inputRef$value2.blur();
    };
    const handleInput = event => {
      handleBaseInput(event);
      resizeTextarea();
    };
    const resizeTextarea = () => {
      var _inputRef$value3;
      if ((_inputRef$value3 = inputRef.value) != null && _inputRef$value3.style) {
        var _inputRef$value4;
        inputRef.value.style.height = "auto";
        inputRef.value.style.height = `${inputRef == null ? void 0 : (_inputRef$value4 = inputRef.value) == null ? void 0 : _inputRef$value4.scrollHeight}px`;
      }
    };
    watch(value, () => {
      resizeTextarea();
    });
    onMounted(resizeTextarea);
    return {
      inputRef,
      valueModel,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleInput,
      handleKeypressEnter,
      focus,
      blur
    };
  }
});